import { Outlet, Link, useNavigate, router, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { AppValues, API, ApiAdmin, GetDate_ } from "../../Values";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
export default function AdminReports() {
  const navigate = useNavigate();
  const [count, Setcount] = useState("0");
  const [Inputs, setInputs] = useState([
    {
      from: GetDate_.FirstMonth,
      to: GetDate_.Today,

    },
  ]);
  //===========Check Login ================
  LoginCheck();
  var admininfo = [];
  var AdminName = "";
  var AdminID = "";
  if (Cookies.get("admininfo")) {
    admininfo = JSON.parse(Cookies.get("admininfo"));
    AdminName = admininfo[0].Name;
    AdminID = admininfo[0].ID;
  }
  const [Orders, SetOrders] = useState([]);
  useEffect(() => {
    setInputs((values) => ({ ...values, ["from"]: GetDate_.FirstMonth }));
    setInputs((values) => ({ ...values, ["to"]: GetDate_.Today }));
  }, []);

  useEffect(() => {
    GetOrdersSearch(GetDate_.FirstMonth, GetDate_.Today);
  }, []);
  //-------------------------------------------------------------
  async function GetOrdersSearch(from, to) {
    try {
      Setcount("0");
      const post = {
        from: from,
        to: to,
        Action: "Arbah",
      };

      if (post.from == null) {
        return alert("الرجاء اختيار تاريخ بداية البحث");
      }
      if (post.to == null) {
        return alert("الرجاء اختيار تاريخ نهاية البحث");
      }

      const response = await fetch(ApiAdmin + "/orders.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      // console.log(data);
      SetOrders(data);
    } catch (error) {
      return error;
    }
  }

  //----------------------------------------
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  return (
    <>
      <Header_ />
      <div
        dir="rtl"
        className="row text-center m-auto"
        style={{ maxWidth: "1000px" }}
      >
        <h3 className="text-orange fw-bold py-1">تقارير الاوردرات</h3>
        {/* -------------- */}
        <div className="col-lg-3 col-5 text-end">
          <label className="col-form-label" autoComplete="off">
            من تاريخ
          </label>
          <input
            type="date"
            name="from"
            className="form-control"
            autoComplete="off"
            // onClick={handleDubelClick}
            onChange={handleChange}
            value={Inputs.from}
          />
        </div>
        <div className="col-lg-3 col-5  text-end">
          <label className="col-form-label" autoComplete="off">
            الى تاريخ
          </label>
          <input
            type="date"
            name="to"
            className="form-control"
            autoComplete="off"
            // onClick={handleDubelClick}
            onChange={handleChange}
            value={Inputs.to}
          />
        </div>
        <div className="col-1 pt-3">
          <button className="btn btn-syan mt-4" onClick={() => GetOrdersSearch(Inputs.from, Inputs.to)}>بحث</button>
        </div>
        {/* ======================= */}

        <div className="col-12">
          <hr />
        </div>
        <div className="col-lg-4 col-md-12 col-12">
          <div className="card shadow m-1">
            <div className="card-body p-2">
              <div
                className="Icon-imgContainer2 p-1"
                style={{ color: "#55C99D", background: "#DCF5EA" }}
              >
                <i className="fa-solid fa-user-secret mt-2"></i>
              </div>
              <h5>  دليفرى ( {Orders.count_dlevary} )</h5>
              <span dir="ltr"></span>
              <table className="table0 w-100">
                <tbody >
                  <tr>
                    <td>عمولة</td>
                    <td> {Orders.mony_dlevary} EG</td>
                  </tr>
                  <tr>
                    <td>ضريبة</td>
                    <td> {Orders.tax_dlevary}  EG</td>
                  </tr>
                  <tr>
                    <td>اجمالى</td>
                    <td> {Orders.total_dlevary}  EG</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* -------------- */}

        <div className="col-lg-4 col-md-12 col-12">
          <div className="card shadow m-1">
            <div className="card-body p-2">
              <div
                className="Icon-imgContainer2 p-1"
                style={{ color: "#EF6242", background: "#FEECDC" }}
              >
                <i className="fa-solid fa-car-side mt-2"></i>
              </div>
              <h5> توصيل سيارات  ({Orders.count_car}) </h5>
              <span dir="ltr"></span>
              <table className="table0 w-100">
                <tbody >
                  <tr>
                    <td>عمولة</td>
                    <td> {Orders.mony_car}  EG</td>
                  </tr>
                  <tr>
                    <td>ضريبة</td>
                    <td> {Orders.tax_car}  EG</td>
                  </tr>
                  <tr>
                    <td>اجمالى</td>
                    <td> {Orders.total_car}  EG</td>
                  </tr>


                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* -------------- */}

        <div className="col-lg-4 col-md-12 col-12">
          <div className="card shadow m-1">
            <div className="card-body p-2">
              <div
                className="Icon-imgContainer2 p-1"
                style={{ color: "#3F83F8", background: "#CCE9FB" }}              >
                <i className="fa-solid fa-motorcycle mt-2"></i>
              </div>
              <h5>  توصيل متوسيكل  ({Orders.count_motosycl}) </h5>
              <span dir="ltr"></span>
              <table className="table0 w-100">
                <tbody >
                  <tr>
                    <td>عمولة</td>
                    <td> {Orders.mony_motosycl}  EG</td>
                  </tr>
                  <tr>
                    <td>ضريبة</td>
                    <td>  {Orders.tax_motosycl}  EG</td>
                  </tr>
                  <tr>
                    <td>اجمالى</td>
                    <td> {Orders.total_motosycl}  EG</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>

  {/* -------------- */}

  <div className="col-lg-4 col-md-12 col-12">
          <div className="card shadow m-1">
            <div className="card-body p-2">
              <div
                className="Icon-imgContainer2 p-1"
                style={{ color: "#EF6242", background: "#FEECDC" }}         >
                <i className="fa-solid fa-caravan mt-2"></i>
            
              </div>
              <h5>   نقل ثقيل  ({Orders.count_nkl}) </h5>
              <span dir="ltr"></span>
              <table className="table0 w-100">
                <tbody >
                  <tr>
                    <td>عمولة</td>
                    <td> {Orders.mony_nkl}  EG</td>
                  </tr>
                  <tr>
                    <td>ضريبة</td>
                    <td>  {Orders.tax_nkl}  EG</td>
                  </tr>
                  <tr>
                    <td>اجمالى</td>
                    <td> {Orders.total_nkl}  EG</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
 


        {/* -------------- */}
        {/* {Orders.count_dlevary != 0 && Orders.count_car != 0 && Orders.count_motosycl != 0 && */}

          <div className="col-lg-4 col-md-12 col-12">
            <div className="card shadow m-1">
              <div className="card-body p-2">
                <div
                  className="Icon-imgContainer2 p-1"
                  style={{ color: "#3F83F8", background: "#CCE9FB" }}              >
                  <i className="ii fa-solid fa-calculator mt-2"></i>
                </div>
                <h5>   الاجمالى </h5>
                <span dir="ltr"></span>
                <table className="table0 w-100">
                  <tbody >
                    <tr>
                      <td>عمولة</td>
                      <td> {Orders.total}  EG</td>
                    </tr>
                    <tr>
                      <td>ضريبة</td>
                      <td>  {Orders.tax}  EG</td>
                    </tr>
                    <tr>
                      <td>اوردرات</td>
                      <td>  {Orders.count_order}  </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        {/* } */}

        {/* -------------- */}

        {/* ============================= */}

      </div>
        <br />
        <br />
        <br />

    </>
  );
}
